import script from "./Monaco.vue?vue&type=script&setup=true&lang=js"
export * from "./Monaco.vue?vue&type=script&setup=true&lang=js"

import "./Monaco.vue?vue&type=style&index=0&id=3dfbd7dd&lang=scss"

const __exports__ = script;

export default __exports__